import { Grid, Typography } from '@mui/material';
import { BffWorkingHours, FacilityDailyWorkingHours } from '@/types/generated';
import TAGDialog from '@shared-components/components/TAGDialog';
import { getTodayWorkingHours, getTodayWorkingHoursFromBff, getWorkingHours, getWorkingHoursFromBff } from '@utils';
export interface IOfficeHours {
  workingHours: FacilityDailyWorkingHours[];
  showCallCenterHours?: boolean;
  handleClose: () => void;
  useFacilityBeffeDataSource?: boolean;
  officeHoursLabel?: string;
  callCenterLabel?: string;
}
interface IHoursSection {
  hoursType: 'callCenter' | 'office';
  todayWorkingHours: string;
  dayHours: {
    day: string;
    hours: string;
  }[];
  showCallCenterHours: boolean;
  officeHoursLabel?: string;
  callCenterLabel?: string;
}
const HoursSection = ({
  hoursType,
  todayWorkingHours,
  dayHours,
  showCallCenterHours,
  officeHoursLabel,
  callCenterLabel
}: IHoursSection) => {
  return <Grid item key={`${hoursType}-item`} data-testid={`${hoursType}_item`} data-sentry-element="Grid" data-sentry-component="HoursSection" data-sentry-source-file="OfficeHours.tsx">
			<Grid item container alignItems="center" direction="column" data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
				<Grid item sx={{
        paddingBottom: 1
      }} data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
					<Typography variant="bodyLargeBold" color="text.primary" component="h2" data-sentry-element="Typography" data-sentry-source-file="OfficeHours.tsx">
						{hoursType === 'callCenter' ? callCenterLabel || 'Call Center Hours' : officeHoursLabel || 'Office Hours'}
					</Typography>
				</Grid>
				<Grid item data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
					<Grid container data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
						<Grid item container gap={1} justifyContent="center" sx={{
            paddingBottom: 1
          }} data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
							<Grid item xs={3} sx={{
              textAlign: 'end'
            }} data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
								<Typography variant="bodyMediumBook" color="success.dark" data-sentry-element="Typography" data-sentry-source-file="OfficeHours.tsx">
									Today:
								</Typography>
							</Grid>
							<Grid item xs={showCallCenterHours ? 8 : 6} data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
								<Typography variant="bodyMediumBook" color="text.tertiary" data-sentry-element="Typography" data-sentry-source-file="OfficeHours.tsx">
									{todayWorkingHours}
								</Typography>
							</Grid>
						</Grid>

						<Grid container gap={1} sx={{
            flexDirection: 'column'
          }} data-sentry-element="Grid" data-sentry-source-file="OfficeHours.tsx">
							{dayHours.map(item => <Grid item container key={`${hoursType}-${item.day}`} gap={1} justifyContent="center">
									<Grid item xs={3} sx={{
                textAlign: 'end'
              }}>
										<Typography variant="bodyMediumBook" color="text.primary">
											{item.day}:
										</Typography>
									</Grid>
									<Grid item xs={showCallCenterHours ? 8 : 6}>
										<Typography variant="bodyMediumBook" color="text.tertiary">
											{item.hours}
										</Typography>
									</Grid>
								</Grid>)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>;
};
const OfficeHours = ({
  workingHours,
  handleClose,
  showCallCenterHours = false,
  useFacilityBeffeDataSource = false,
  officeHoursLabel,
  callCenterLabel
}: IOfficeHours) => {
  const todayWorkingHours = useFacilityBeffeDataSource ? getTodayWorkingHoursFromBff(workingHours as BffWorkingHours[]) : getTodayWorkingHours(workingHours);
  const dayHours = useFacilityBeffeDataSource ? getWorkingHoursFromBff(workingHours as BffWorkingHours[]) : getWorkingHours(workingHours);
  return <TAGDialog open showCloseIcon handleClose={handleClose} maxWidth={false} fullWidth sx={{
    padding: '0px'
  }} data-testid="office_hours_dialog" renderActions={() => <Grid sx={{
    padding: {
      sm: '40px',
      xs: '40px 10px'
    }
  }}>
					<Grid container>
						<Grid item xs={showCallCenterHours ? 6 : 12}>
							<HoursSection hoursType="office" todayWorkingHours={todayWorkingHours} dayHours={dayHours} showCallCenterHours={showCallCenterHours} officeHoursLabel={officeHoursLabel} callCenterLabel={callCenterLabel} />
						</Grid>
						{showCallCenterHours && <Grid item xs={6}>
								<HoursSection hoursType="callCenter" todayWorkingHours={todayWorkingHours} dayHours={dayHours} showCallCenterHours={showCallCenterHours} officeHoursLabel={officeHoursLabel} callCenterLabel={callCenterLabel} />
							</Grid>}
					</Grid>
				</Grid>} data-sentry-element="TAGDialog" data-sentry-component="OfficeHours" data-sentry-source-file="OfficeHours.tsx" />;
};
export default OfficeHours;